import type {
  CompositionV3DataQueryVariables,
  CompositionV3Ent,
  CompositionV3Filters,
} from '@revelio/data-access';

import { DEFAULT_SKILL_TAXONOMY_ID } from '../../contexts/defaultFilters';
import { stripEntitiesFromFilters } from '../role-skill-ent-kind';
import { getCompositionV3BreakdownOptions } from './getCompositionV3BreakdownOptions';

/**
 * Assembles the full set of `composition_v3` query variables for callers that
 * already have v3-native entities + filters (game, AI-search, IP). Fills the
 * `corrections` (weighting) and `breakdown_options` the schema requires non-null.
 *
 * `raw` mirrors the legacy weighting toggle: raw data drops the sample weight.
 */
export const buildCompositionV3Variables = ({
  entities,
  filters = {},
  roleTaxonomy = 0,
  skillTaxonomy = DEFAULT_SKILL_TAXONOMY_ID,
  raw = false,
  contingentWorkers = false,
}: {
  entities: CompositionV3Ent[];
  filters?: CompositionV3Filters;
  roleTaxonomy?: number;
  skillTaxonomy?: number;
  raw?: boolean;
  contingentWorkers?: boolean;
}): CompositionV3DataQueryVariables => ({
  entities,
  filters: stripEntitiesFromFilters(filters, entities),
  corrections: {
    with_sample_weight: true,
    with_weight: raw !== true,
    with_contingent_workers: contingentWorkers,
  },
  role_taxonomy: roleTaxonomy,
  skill_taxonomy: skillTaxonomy,
  breakdown_options: getCompositionV3BreakdownOptions({
    compositionFilters: filters,
  }),
});
